class CustomSelectModule {
    constructor() {
        this.initialize();
    }

    initialize() {
        this.bindUI();
        this.bindEvents();
    }

    bindUI() {
        this.ui = {};
        this.ui.customSelect = document.querySelectorAll('.js-apply-iframe-trigger');
        this.ui.formIframes = document.querySelectorAll('.rte iframe');
    }

    bindEvents() {
        [].forEach.call(this.ui.customSelect, (item, index) => {
           item.addEventListener('change', this.onChangeSelect.bind(this));
        });
    }

    onChangeSelect(e) {
        const currentTarget = e.currentTarget;
        [].forEach.call(this.ui.formIframes, (item, index) => {
            item.classList.remove("is-active");
        });

        this.ui.formIframes[currentTarget.value].classList.add("is-active");
    }
}



export default CustomSelectModule;
